<template>
  <div id="top">
    <headNav :gray="gray"></headNav>
    <!--container-->
    <div class="innerWrapper">
      <h1>About us</h1>
      <h2>
        Integrity! Transparency! Quality! This is what UNIFI represents. UNIFI
        is a Business to Business platform that is revolutionising the way that
        off-the-plan and new property is being purchased.<br />
        <br />
        UNIFI is a property platform that will assist all investors and home
        buyers and give them access to pre-qualified, researched and quality
        properties. Whether it is an off-the-plan townhouse, apartment, sky
        terrace or house and land package, we ensure that a rigorous selection
        process is undertaken prior to approving a property to be released on
        the UNIFI platform. Quality is something that will not be compromised.
        With easy-to-access due diligence available for all properties, finding
        the right one for your client will be easy.<br /><br />
        UNIFI is unifying all industries and offering a seamless purchasing
        method for introducers and buyers alike. Mortgage and Finance Brokers,
        Accountants, Real Estate Agents, Financial Planners and qualified
        advisors gain access to all properties on the platform being able to
        match the right property to their client's needs. With accessibility in
        mind, our referrers can filter through and find the perfect property for
        their client within minutes. Assisting clients in purchasing the perfect
        property has never been easier.
      </h2>
      <div class="bigImg"></div>
    </div>
    <!--footer-->
    <foot-nav></foot-nav>
  </div>
</template>

<script>
import headNav from "@/components/package/nav";
import footNav from "@/components/package/footer";

export default {
  data() {
    return {
      showTitle: false,
      gray: true
    };
  },
  components: {
    headNav,
    footNav
  },
  mounted() {
    document.getElementById("top").scrollIntoView();
  }
};
</script>

<style lang="scss" scoped>
.innerWrapper {
  width: 100%;
  padding: 1.04rem 0 0 0;
  box-sizing: border-box;
  margin: 0 auto;

  h1 {
    font-size: 0.56rem;
    line-height: 0.68rem;
    color: #2a2929;
    margin-bottom: 0.32rem;
    font-family: ProximaNova-Semibold;
    padding: 0.48rem 0.24rem 0 0.24rem;
    box-sizing: border-box;
  }

  h2 {
    font-size: 0.28rem;
    margin-bottom: 0.96rem;
    line-height: 0.42rem;
    color: #3f3f46;
    word-break: break-word;
    padding: 0 0.24rem;
    box-sizing: border-box;
  }

  .bigImg {
    width: 100%;
    height: 5rem;
    margin-bottom: 0.8rem;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    background-image: url("https://s3-ap-southeast-2.amazonaws.com/com.unifiproperty/files/images/lALPBF8a6aDY23PNA6HNBG0_1133_929.png");
  }
}
</style>



// WEBPACK FOOTER //
// src/components/more/abous.vue